<template :emitHandler="emitHandler">
  <notification-item
    v-bind="props"
    @wasDismissed="dismissBanner"
    @isDismissed="isDismissed"
    @elBlur="blurHandler"
    @elFocus="focusHandler"
  ></notification-item>
</template>

<script setup>
import NotificationItem from '../NotificationItem/NotificationItem.vue'
import { onBeforeMount, ref } from 'vue';
import { useCookies } from '../../hooks/useCookies';
const { getCookie, setCookie, expireCookie } = useCookies();
const isDismissed = ref(false);

const props = defineProps({
  cookieName: {
    type: String,
    default:''
  },
  showGloballyUntil: {
    type: String,
    default:''
  },
  bannerLastUpdated: {
    type: String,
    default:''
  },
  alertId: {
    type: String,
    required: true,
  },
  removeEl: {
    type: Function,
    default: () => {},
  },
  blurHandler: {
    type: Function,
    default: () => {},
  },
  focusHandler: {
    type: Function,
    default: () => {},
  },
  ...NotificationItem.props,
});

const setBannerCookie = () => {

  if (!props.cookieName || !props.bannerLastUpdated) {
    return;
  }
  const currentCookie = getCookie(props.cookieName);

  let value = ''

  if (currentCookie && currentCookie !== '') {
    value = `${currentCookie}&${props.alertId}-${props.bannerLastUpdated}`;
  } else {
    value = `${props.alertId}-${props.bannerLastUpdated}`;
  }

  setCookie(props.cookieName, props.showGloballyUntil, value);
};

const checkCookies = () => {
  if (!props.cookieName) {
    return;
  }
  // Check for the cookie
  const currentCookie = getCookie(props.cookieName);
  if (currentCookie) {
    const cookieValueArray = currentCookie.split('&')
    const hasBeenDismissedBefore = cookieValueArray.indexOf(`${props.alertId}-${props.bannerLastUpdated}`) !== -1
    if (hasBeenDismissedBefore) {
      props.removeEl(props.alertId);
    }
  }
};

const checkBannerExpiry = () => {
  if (!props.showGloballyUntil) {
    return;
  }
  const today = new Date(new Date().toDateString());
  const expireDate = new Date(new Date(props.showGloballyUntil).toDateString());
  const hasExpired = expireDate < today;

  if (hasExpired && props?.removeEl) {
    props.removeEl(props.alertId)
  }
};

const focusHandler = () => {
  props.focusHandler()
}

const blurHandler = () => {
  props.blurHandler()
}

const dismissBanner = () => {
  props.removeEl(props.alertId)

  // If the component is running in storybook we skip the set cookie step
  if (window.IS_STORYBOOK) {
    return;
  }
  setBannerCookie();
};

onBeforeMount(() => {
  if (props.isNotDismissible) {
    return;
  }

  // Before mount we check if the banner has been dismissed before and if the banner should still be shown
  checkCookies();
  checkBannerExpiry();
});

</script>
